import React from 'react';
// import Header from './Header';
import HeroSection from './HeroSection';
import MultilingualismSection from './MultilingualismSection';

const Index = () => {
  return (
    <div className="flex flex-col items-center bg-[#f4f8f7] w-full min-h-screen">
      {/* <Header className="w-full" /> */}
      <div className="flex flex-col items-center w-full max-w-[1201px]">
        <HeroSection className="flex-grow w-full" />
        <MultilingualismSection className="flex-grow w-full" />
      </div>
    </div>
  );
};

export default Index;

